import { render, staticRenderFns } from "./VideoMount.vue?vue&type=template&id=19a44a5c&"
import script from "./VideoMount.vue?vue&type=script&lang=js&"
export * from "./VideoMount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports